import MainInterface from "./MainInterface.jsx";

export default MainInterface;
